import React from 'react'

export const Temporal: React.FC = () => {
  return (
    <div className='temporal'>
      <p>Services Page Cominig Up soon!!</p>
    </div>
  )
}
